import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'Utils/store'
import { multiSelectSlice } from 'Slices/multiSelectSlice'
import CompetitiveCandidatesConfig from 'Configs/fields/competitive_candidates.json'
import { ContractSource } from 'Types/contractTypes'

const contractSource = ContractSource.candidates

const transformValues = function (selectedValues) {
  return selectedValues.map((value) => value.match(/\d+/)?.[0])
}

export const CompetitiveCandidatesSlice = multiSelectSlice(
  CompetitiveCandidatesConfig.column,
  'setCompetitiveCandidates',
  CompetitiveCandidatesConfig.data,
  CompetitiveCandidatesConfig.meta,
  transformValues
)

export const selectCompetitiveCandidates = createSelector(
  ({ onDemandFilter: { competitiveCandidates } }: RootState) =>
    competitiveCandidates.selectedValues,
  (
    selectedValues: string[]
  ): {
    selectedValues: string[]
    values: string[]
    audienceTypes: string[]
    label
  } => {
    return {
      selectedValues,
      values: CompetitiveCandidatesConfig.data,
      audienceTypes:
        CompetitiveCandidatesConfig.source[contractSource].audience_types,
      label: CompetitiveCandidatesConfig.meta.label,
    }
  }
)

export const { setCompetitiveCandidates } = CompetitiveCandidatesSlice.actions

export default CompetitiveCandidatesSlice.reducer
